import type { ColumnState } from "ag-grid-community";
import type { ActiveReportArtifact } from "~/utils/types/assistant-report-artifact";

export const buildCommittedColumnState = (artifact: ActiveReportArtifact): ColumnState[] =>
  artifact.presentation.fieldKeys.map(fieldKey => ({
    colId: fieldKey,
    hide: false,
    sort: artifact.presentation.sort?.fieldKey === fieldKey ? artifact.presentation.sort.direction : null,
    sortIndex: artifact.presentation.sort?.fieldKey === fieldKey ? 0 : null,
  }));

export const reportArtifactVersionKey = (artifact: ActiveReportArtifact): string => `${artifact.artifactId}:${artifact.version}`;

export const shouldReconcileArtifactVersion = (reconciledVersionKey: string | null, artifact: ActiveReportArtifact): boolean =>
  reconciledVersionKey !== reportArtifactVersionKey(artifact);

interface ReconciliationApi {
  setFilterModel: (model: null) => void;
  resetColumnState: () => void;
  applyColumnState: (params: { state: ColumnState[]; applyOrder: true }) => boolean;
  autoSizeAllColumns: (skipHeader: boolean) => void;
}

export const reconcileCommittedArtifact = (
  api: ReconciliationApi,
  artifact: ActiveReportArtifact,
  schedule: (callback: () => void) => void = callback => requestAnimationFrame(callback),
): void => {
  api.setFilterModel(null);
  api.resetColumnState();
  api.applyColumnState({ state: buildCommittedColumnState(artifact), applyOrder: true });
  schedule(() => api.autoSizeAllColumns(false));
};
